// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__21IC2","inner":"Footer_inner__31rVp","nextIcon":"Footer_nextIcon__3bMZA","innerLeft":"Footer_innerLeft__1pwz3"};